/**
 * <Can> — gate de UX por capability/role (S3.6).
 *
 * Renderiza os children apenas se a role atual tiver a permissão. Caso
 * contrário renderiza `fallback` (default: nada). É só UX — o backend continua
 * sendo a fonte da verdade (403).
 *
 * Uso:
 *   <Can capability="devices:command"><button>Reiniciar</button></Can>
 *   <Can role="super_admin"> ...item de menu only-admin... </Can>
 *   <Can capability="fleet:write" fallback={<Somente leitura/>}> ... </Can>
 */
import { hasCapability, hasRole } from "../lib/rbac.js";

export default function Can({ capability, role, fallback = null, children }) {
  let ok = true;
  if (role) ok = hasRole(role);
  else if (capability) ok = hasCapability(capability);
  return ok ? children : fallback;
}
